document.addEventListener("DOMContentLoaded", function () {
    var cookieBanner = document.querySelector("#shopify-pc__banner");
    if (cookieBanner) {
        cookieBanner.style.display = "none";
        cookieBanner.style.visibility = "hidden";
    }

    var attempts = 0;
    function acceptCookiesShopify() {
        if (window.Shopify && Shopify.customerPrivacy) {
            Shopify.customerPrivacy.setTrackingConsent({
                analytics: true,
                marketing: true,
                preferences: true,
                sale_of_data: true
            }, function () {});
            return; // done - no more polling
        }
        if (++attempts < 15) setTimeout(acceptCookiesShopify, 1000); // retry for up to ~15s, then stop
    }

    acceptCookiesShopify();
});
